// unique scripts go here.

const tnsInstancing = () => {
	let openingCarousel = document.querySelector('.site-opening');

	if (openingCarousel !== null) {
		let oc = tns({
			container: '.site-opening',
			items: 1,
			controls: false,
			autoplayButtonOutput: false,
      autoplay: true,
      autoplaySpeed: 3000
		});
	}

	let testimonialCarousel = document.querySelector('.tns-testimonials');

	if (testimonialCarousel !== null) {
		let tc = tns({
			container: '.tns-testimonials',
			items: 1,
			speed: 800,
			autoHeight: true,
			nav: true,
			controls: false,
			gutter: 30,
			mouseDrag: true,
			responsive: {
				1000: {
					nav: false,
					items: 3,
					center: false,
				}
			}
		});
	}

	let customerCarousel = document.querySelector('.tns-customers');

	if (customerCarousel !== null) {
		let cc = tns({
			container: '.tns-customers',
			items: 1,
			controls: false,
			nav: true,
			speed: 800,
			gutter: 42,
			center: true,
			mouseDrag: true,
			responsive: {
				1000: {
					items: 5,
					center: false,
				}
			}
		});
	}

	let becomesCarouselMobile = document.querySelectorAll('.becomes-carousel-on-mobile');

	if (becomesCarouselMobile !== null && helpers.isMobile) {
		becomesCarouselMobile.forEach((item, idx) => {
			window[`mobileSlider` + idx] = tns({
				container: item,
				mouseDrag: true,
				center: true,
				speed: 1000,
				nav: true,
				controls: false,
			});
		})
	}
}

const sendCommentToDB = e => {
	e.preventDefault();

	const {
		currentObjectID,
		adminURL
	} = helpers.wpVars;


	const fData = new FormData(e.target);
	let commentData = {};

	// From array to JSON
	for (var pair of fData.entries()) {
		commentData[pair[0]] = pair[1];
	}

	commentData.userAgent = navigator.userAgent;
	commentData.objectID = currentObjectID;

	let send = fetchResults(adminURL, 'add_comment_to_db', commentData);
	send.then(response => {
		console.log(response);
	})
}

const genericFade = e => {
	let target = document.querySelector(e.target.dataset.target);
	let fade = e.target.dataset.fade;

	if (fade === 'out') {
		fadeOut(target);
	} else {
		fadeIn(target);
	}
}

const inputHandler = (masks, max, event) => {
	var c = event.target;
	var v = c.value.replace(/\D/g, '');
	var m = c.value.length > max ? 1 : 0;
	VMasker(c).unMask();
	VMasker(c).maskPattern(masks[m]);
	c.value = VMasker.toPattern(v, masks[m]);
}

const handleForm = () => {
	const forms = document.querySelectorAll('form')

	forms ? (
		forms.forEach(form => {
			form.addEventListener('submit', e => {
				e.preventDefault()

				e.target.setAttribute('disabled', 'disabled')
				let formData = new FormData(form)
				formData.append('action', 'iv_submit_emails')
				let request = fetch(helpers.wpVars.adminURL, {
					method: 'POST',
					body: formData
				}).then(response => {
					if( response.status == 200 ) {
						ga('gtm1.send', 'event', 'Formulário', 'Envio', 'Formulário')
						
						Swal.fire({
							title: 'Formulário enviado com sucesso!',
							icon: 'success',
							confirmButtonText: 'Ok'
						})
					} else {
						Swal.fire({
							title: 'Erro ao enviar os dados. Favor tentar novamente',
							icon: 'error',
							confirmButtonText: 'Ok'
						})
					}

					e.target.removeAttribute('disabled', 'disabled')
				})
			})
		})
	) : false
}